import React from "react";
import { Rss } from "lucide-react";
import { LiveOrderAuditLog } from "../components/LiveOrderAuditLog";
import { LiveOrdersHistory } from "../components/LiveOrdersHistory";
import { UpstoxConnectivityBanner } from "../components/UpstoxConnectivityBanner";
import { HardKillSwitch } from "../components/HardKillSwitch";
import { MyLiveTrades } from "../components/MyLiveTrades";
import { TodayLivePnl } from "../components/TodayLivePnl";
import { useAuth } from "../auth/AuthContext";

// 2026-08-28 — dedicated top-level Live Orders page (chat: "For Stocks, it
// is better to re-align Live Orders into a new page (Live Orders), which
// basically tracks Live Orders of all users (if any)"). Previously
// LiveOrderAuditLog + LiveOrdersHistory lived inline at the top of the
// Dashboard's Auto Picks tab, above VWAPBounce/OIAutopilot/CandleBreakout —
// pulled out here so it's its own destination instead of sharing space with
// the setup cards.
//
// 2026-10-13 — chat: "For new user, they don't see Live Orders menu at all. At
// least user should see Live orders and list of trades". Every signed-in user
// now gets this page. A non-admin sees only their own trades (MyLiveTrades —
// the linked Zerodha account's real orders from kite_mirror, stocks and
// commodities); the global kill switch, broker banner and all-users audit log
// stay admin-only.
const LiveOrders = () => {
  const { isAdmin } = useAuth();
  return (
    <section className="space-y-8" data-testid="live-orders-page">
      <div>
        <div className="text-[10px] uppercase tracking-[0.3em] text-muted-3 font-mono-data mb-1">
          {isAdmin ? "Stocks · all users" : "Your account"}
        </div>
        <h2 className="font-heading text-2xl flex items-center gap-2">
          <Rss size={20} /> Live Orders
        </h2>
        <div className="text-[10px] text-muted-3 font-mono-data mt-1">
          {isAdmin
            ? "Every live order across Sniper, Candle Breakout, OI Autopilot, VWAP Bounce and Momentum OI, for every user."
            : "Real trades placed in your Zerodha account by the autopilot — stocks and commodities."}
        </div>
      </div>

      {isAdmin ? (
        <>
          <HardKillSwitch />
          {/* 2026-10-30 — realized P&L today from real Kite fills: autopilot +
              copied + MANUAL trades (the audit log below lists autopilot orders only). */}
          <TodayLivePnl market="stocks" testid="stocks-today-pnl" />
          <UpstoxConnectivityBanner />
          <LiveOrderAuditLog />
          <LiveOrdersHistory />
        </>
      ) : (
        <MyLiveTrades />
      )}
    </section>
  );
};

export default LiveOrders;
